import Landing from "../Landing";
import Verification from "../authentication/Verification";
import Login from "../authentication/Login";
import CustomerJourney from "pages/CustomerJourney/customerJourney";
import Signup from "../authentication/Signup";
import Dashboard from "pages/Dashboard";
import IndustryDashboard from "pages/IndustryDashboard";
import SharedDashboard from "pages/SharedDashboard";
import DashboardData from "pages/DashboardData";
import NewDashboard from "pages/NewDashboard";
import AllDashboards from "pages/AllDashboards";
import Journey from "pages/Journey";
import Report from "pages/Report";
import FollowedTopics from "pages/FollowedTopics";
import Insights from "pages/Insights";
import SharedInsights from "pages/SharedInsights";
import SpecialSignup from "authentication/SpecialSignup";
import AppSumo from "LandingComponents/AppSumo";
import InvitedUsers from "LandingComponents/InvitedUsers";
import Details from "pages/Profile/details";
import Preferences from "pages/Profile/preferences";
import HotTermsPage from "pages/Profile/hotterms";
import Team from "pages/Profile/team";
import Organizations from "pages/Profile/organization";
import security from "pages/Profile/security";
import Plan from "pages/Profile/plan";
import AiCreditsPage from "pages/Profile/aiCredits";
import Integrations from "pages/Profile/integrations";
import InviteTeam from "pages/Profile/team/invite";
import mfa from "pages/Profile/security/mfa";
import GlobalExecutiveDashboard from "pages/GlobalExecutiveDashboard";
import TopicLibrary from "pages/TopicLibrary";
import Engage from "pages/Engage";
import ReportsDownloads from "pages/ReportsDownloads";
import Tags from "pages/Tags";
import Alerts from "pages/Alerts";
import Survey from "pages/SurveyRepository";
import SavedSearches from "pages/SavedSearches";
import WelcomePage from "pages/Welcome";
import DiscoverProducts from "pages/DiscoverProducts";
import IndividualWidget from "pages/IndividualWidget";
import CombinedView from "pages/CombinedView/CombinedView";
import TopicGapConcepts from "pages/TopicGapConcepts";
import TopProblemsRedirect from "pages/Dashboard/TopProblemsRedirect";
import AiAutoRefreshSettings from "pages/AiServices/AutoRefreshSettings";
import AiReportsPage from "pages/AiServices/AiReports";
import AiReportDetail from "pages/AiServices/AiReportDetail";
import AdvisorPage from "pages/Advisor";
import AdvisorVoiceRedirect from "pages/Advisor/AdvisorVoiceRedirect";
import NotificationsPage from "pages/Notifications";
import AdvisorHistoryPage from "pages/Profile/advisorHistory";
import GenaiQueuePage from "pages/Profile/genaiQueue";
import EngagementPage from "pages/Profile/engagement";
import MarketIntelligencePreviewPage from "pages/Profile/marketIntelligencePreview";
import EmailReportsPage from "pages/Profile/emailReports";
import Sonic from "pages/Sonic";
import SonicProspect from "pages/SonicProspect";
import ProspectPlansPage from "pages/SonicProspect/ProspectPlansPage";
import ExampleLinks from "pages/SonicProspect/ExampleLinks";
import DemoConversations from "pages/SonicProspect/DemoConversations";
import Customer365 from "pages/Customer365";
import ZendeskPage from "pages/Zendesk";
import BehavioralSegmentation from "pages/BehavioralSegmentation";
import TeachAI from "pages/TeachAI";
import WhatsappInbox from "pages/WhatsappInbox";
import PublicSurvey from "pages/PublicSurvey";
import PublicBooking from "pages/SonicCalendar/PublicBooking";
import PublicAppointment from "pages/SonicCalendar/PublicAppointment";
import ProspectDemoPanel from "pages/ProspectDemo/Panel";
import ProspectExamples from "pages/ProspectDemo/Examples";
import { DemoRoute, ExampleRedirect } from "pages/ProspectDemo/DemoRoute";
import FeedbackCapture from "pages/FeedbackCapture";
import FeedbackResponsesPage from "pages/FeedbackCapture/responses/ResponsesPage";
import SurveySettingsPage from "pages/FeedbackCapture/settings";
import SurveyManagement from "pages/SurveyManagement";
import ShopifySso from "pages/ShopifySso";
import WhatsNewPage from "pages/WhatsNew";
import WhatsNewCms from "pages/WhatsNew/WhatsNewCms";

export const routes = [
  {
    path: "/",
    type: Landing,
  },
  {
    path: "/verification",
    type: Verification,
  },
  {
    path: "/console/my-workspace",
    type: WelcomePage,
  },
  {
    path: "/widget/:widgetId",
    type: IndividualWidget,
  },
  {
    path: "/console",
    type: AdvisorPage,
  },
  {
    path: "/console/myDashboards",
    type: AllDashboards,
  },
  {
    path: "/console/source",
    type: NewDashboard,
  },
  {
    path: "/console/report",
    type: ReportsDownloads,
  },
  {
    path: "/console/reportt",
    type: Report,
  },
  {
    path: "/console/Dashboard/:id",
    type: Dashboard,
  },
  {
    path: "/console/industryTopics",
    type: IndustryDashboard,
  },
  {
    path: "/console/customTopics/:id",
    type: CombinedView,
  },
  {
    path: "/console/DashboardData/:id",
    type: DashboardData,
  },
  {
    path: "/console/savedSearches/:id",
    type: SavedSearches,
  },
  // {
  //     path: '/console/geolocation/:id',
  //     type: Geolocation
  // },
  {
    path: "/console/global_executive",
    type: GlobalExecutiveDashboard,
  },
  {
    path: "/console/topicLibrary",
    type: TopicLibrary,
  },
  {
    path: "/console/topicLibrary/custom_topics",
    type: TopicLibrary,
  },
  {
    path: "/console/topicLibrary/industry_topics",
    type: TopicLibrary,
  },
  {
    path: "/console/tags",
    type: Tags,
  },
  {
    path: "/console/alerts",
    type: Alerts,
  },
  {
    path: "/console/notifications",
    type: NotificationsPage,
  },
  {
    path: "/console/survey",
    type: Survey,
  },
  {
    path: "/s/:slug",
    type: PublicSurvey,
    public: true,
  },
  {
    path: "/book/:slug",
    type: PublicBooking,
    public: true,
  },
  {
    path: "/appointment/:token",
    type: PublicAppointment,
    public: true,
  },
  {
    path: "/demos/examples",
    type: ProspectExamples,
    public: true,
  },
  {
    path: "/demos/examples/:slug",
    type: ExampleRedirect,
    public: true,
  },
  {
    path: "/demos/:slug",
    type: DemoRoute,
    public: true,
  },
  {
    path: "/demos/:slug/panel",
    type: ProspectDemoPanel,
    public: true,
  },
  {
    path: "/auth/shopify",
    type: ShopifySso,
    public: true,
  },
  {
    path: "/console/sonic-survey",
    type: FeedbackCapture,
  },
  {
    path: "/console/sonic-survey/settings",
    type: SurveySettingsPage,
  },
  {
    path: "/console/sonic-survey/:id/responses",
    type: FeedbackResponsesPage,
  },
  {
    path: "/console/surveys",
    type: SurveyManagement,
  },
  {
    path: "/console/journeys",
    type: CustomerJourney,
  },
  {
    path: "/console/advisor-voice",
    type: AdvisorVoiceRedirect,
  },
  {
    path: "/console/pivony-sonic/voice-agent",
    type: AdvisorVoiceRedirect,
  },
  {
    path: "/console/sonic-prospect/example-links",
    type: ExampleLinks,
  },
  {
    path: "/console/sonic-prospect/plans",
    type: ProspectPlansPage,
  },
  {
    path: "/console/sonic-prospect",
    type: SonicProspect,
  },
  {
    path: "/console/sonic",
    type: Sonic,
  },
  {
    path: "/console/zendesk",
    type: ZendeskPage,
  },
  {
    path: "/console/customer-365/:profileRef",
    type: Customer365,
  },
  {
    path: "/console/customer-365",
    type: Customer365,
  },
  {
    path: "/console/behavioral-segmentation",
    type: BehavioralSegmentation,
  },
  {
    path: "/console/teach-ai",
    type: TeachAI,
  },
  {
    path: "/console/whatsapp",
    type: WhatsappInbox,
  },
  {
    path: "/share/Dashboard/:id",
    type: SharedDashboard,
    props: {
      shared: true,
    },
  },
  {
    path: "/share/DashboardData/:id",
    type: DashboardData,
    props: {
      shared: true,
    },
  },
  {
    path: "/share/insights/:id",
    type: SharedInsights,
    props: {
      shared: true,
    },
  },

  {
    path: "/console/journey/:id",
    type: Journey,
  },
  {
    path: "/console/insights/:id",
    type: Insights,
  },
  {
    path: "/console/engage",
    type: Engage,
  },
  {
    path: "/console/engage/audience",
    type: Engage,
  },
  {
    path: "/console/engage/emailMarketing",
    type: Engage,
  },
  // /console/followed and /console/topicLibrary* redirect to /settings/topic-library in App.js
  {
    path: "/login",
    type: Login,
  },
  {
    path: "/signup",
    type: Signup,
  },
  {
    path: "/checkout",
    type: Signup,
  },
  {
    path: "/checkout/special",
    type: SpecialSignup,
  },
  {
    path: "/checkout/app_sumo",
    type: AppSumo,
  },
  {
    path: "/settings",
    type: Details,
  },
  {
    path: "/settings/details",
    type: Details,
  },
  {
    path: "/settings/preferences",
    type: Preferences,
  },
  {
    path: "/settings/users",
    type: Team,
  },
  {
    path: "/settings/team/invite/:id?",
    type: InviteTeam,
  },
  {
    path: "/settings/security",
    type: security,
  },
  {
    path: "/settings/security/enable/2fa",
    type: mfa,
  },
  {
    path: "/settings/teams",
    type: Organizations,
  },
  {
    path: "/settings/plan",
    type: Plan,
  },
  {
    path: "/settings/ai-credits",
    type: AiCreditsPage,
  },
  {
    path: "/settings/integrations",
    type: Integrations,
  },
  {
    path: "/settings/topic-library",
    type: TopicLibrary,
  },
  {
    path: "/settings/hot-terms",
    type: HotTermsPage,
  },
  {
    path: "/settings/advisor-history",
    type: AdvisorHistoryPage,
  },
  {
    path: "/settings/genai-queue",
    type: GenaiQueuePage,
  },
  {
    path: "/settings/engagement",
    type: EngagementPage,
  },
  {
    path: "/settings/email-reports",
    type: EmailReportsPage,
  },
  {
    path: "/settings/market-intelligence-preview",
    type: MarketIntelligencePreviewPage,
  },
  // {
  //   path: "/sentiment_intent_analyzer",
  //   type: AppSumoBlackFriday,
  // },
  {
    path: "/users/:org_name/user_auth",
    type: InvitedUsers,
  },
  {
    path: "/console/combined-view/:id",
    type: CombinedView,
  },
  {
    path: "/console/topic-gap/:id",
    type: TopicGapConcepts,
  },
  {
    path: "/console/top-problems/:id",
    type: TopProblemsRedirect,
  },
  {
    path: "/console/ai-services/auto-reports-settings",
    type: AiAutoRefreshSettings,
  },
  {
    path: "/console/ai-services/auto-reports/:reportId",
    type: AiReportDetail,
  },
  {
    path: "/console/ai-services/auto-reports",
    type: AiReportsPage,
  },
  {
    path: "/console/advisor",
    type: AdvisorPage,
  },
  {
    path: "/console/discover-products",
    type: DiscoverProducts,
  },
  {
    path: "/console/whats-new",
    type: WhatsNewPage,
  },
  {
    path: "/console/whats-new/:id",
    type: WhatsNewPage,
  },
  {
    path: "/console/ops/whats-new-cms",
    type: WhatsNewCms,
  },
  {
    path: "/console/ops/demo-conversations",
    type: DemoConversations,
  },
];
